<template>
	<div id="settingLayout" class="layout-container">
		<Menu :menuName="menuName" />
		<Topbar ref="topbar" :menuName="menuName" />
		<div class="setting-contents-container" :class="isLoading ? 'loading' : ''">
			<router-view ref="router" :class="isLoading ? 'blur' : ''" />
		</div>
	</div>
</template>

<script>
import EventBus from "@/script/EventBus.js";
import Menu from "@/components/left/Menu.vue";
import Topbar from "@/components/left/Topbar.vue";

export default {
	name: "SettingLayout",
	components: {
		Menu,
		Topbar
	},
	created() {
		this.logger.debug(this, "created()");

		// 로딩바 닫기
		EventBus.$on("setting-loading", (isLoading) => {
			this.logger.debug(this, "[EventBus] loading(isLoading)");
			this.isLoading = isLoading;
		});
		// CRUD 새 창 닫기
		EventBus.$on("setting-cancel", (target) => {
			this.logger.debug(this, "[EventBus] cancel(target)");
			if(target === "isSiteCreate" || target === "isAuthCreate") this.$refs.router.$data.isCreate = false;
			else if(target === "isSiteEdit" || target === "isAuthEdit") this.$refs.router.$data.isEdit = false;
			else if(target === "isDatabaseCreate") this.$refs.router.$data.isDatabaseCreate = false;
			else if(target === "isDatabaseEdit") this.$refs.router.$data.isDatabaseEdit = false;
			else if(target === "isEmrUpload") this.$refs.router.$data.isUpload = false;
			else if(target === "isEmrColumnManageCreate") this.$refs.router.$data.isCreate = false;
			else if(target === "isEmrColumnManageEdit") this.$refs.router.$data.isEdit = false;
			else if(target === "isEmrEdit") this.$refs.router.$data.isEmrEdit = false;
			else if(target === "isDataCreate") this.$refs.router.$data.isDataCreate = false;
		});
	},
	beforeDestroy() {
		EventBus.$off('setting-loading');
		EventBus.$off('setting-cancel');
	},
	data() {
		return {
			menuName: "Setting",
			isLoading: true
		};
	}
};
</script>

<style scoped>
@import "../../assets/css/setting/setting.css";
</style>